import { render } from "./BookingPreferences.vue?vue&type=template&id=2b399d3a&scoped=true"
import script from "./BookingPreferences.vue?vue&type=script&lang=js"
export * from "./BookingPreferences.vue?vue&type=script&lang=js"

import "./BookingPreferences.vue?vue&type=style&index=0&id=2b399d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b399d3a"]])

export default __exports__